import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGroup, Grid, InputAdornment, TextField, Typography } from "@mui/material";

import RegularButton from "components/CustomButtons/Button";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { useForm } from "hooks/useForm";
import { useSearch } from "hooks/useSearch";
import { validateObject } from "helpers/validateObject";

import {
  getPolicyNumber,
  createPolicyManagmentAction,
  getPolicyManagmentsAction,
  handlePolicyManagmentsInputsAction,
  deletePolicyManagmentAction,
} from "redux/actions/policyManagment/policyManagmentActions";

import { PolicyCounters } from "./PolicyCounters";
import { newDate } from "helpers/dateTools";

export const LoadPolicyInputs = ({ close }) => {
  const type = "INGRESO";
  const dispatch = useDispatch();
  const { companiesList } = useSelector(({ companies }) => companies);
  const { company, station, policyNumber, date, policy } = useSelector(
    ({ policyManagment }) => policyManagment
  );
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { setSnackbar } = useSearch();
  const {
    values: { concept },
    setValues,
  } = useForm({ concept: "" });

  const handleSearchPolicyNumber = useCallback(() => {
    if (!company || !station || !date)
      return setSnackbar("Es necesario Compañia, Empresa y Fecha", "warning");
    dispatch(getPolicyNumber(company.id, station.id, date));
  }, [company, station, date]);

  const handleSubmit = useCallback((isCreate = true) => {
    if (!company || !station || !date || !policyNumber)
      return setSnackbar(
        "Es necesario Compañia, Empresa, Fecha y Numero de Poliza",
        "warning"
      );
    const form = {
      idCompany: company.id,
      idStation: station.id,
      date,
      concept,
      type,
      policyNumber,
    };
    isCreate
      ? dispatch(
          createPolicyManagmentAction({ ...form, number: policyNumber }, close)
        )
      : dispatch(getPolicyManagmentsAction(form));
  }, [company, station, date, policyNumber, concept, type, close]);

  useEffect(() => {
    station !== null &&
      setValues({
        concept: `${type} / ${company?.label || ""} / ${station?.label ||
          ""} / ${date}`,
      });
    // eslint-disable-next-line
  }, [company, station, date]);

  return (
    <>
      <Grid item xs={12} sm={12} md={6}>
        <AutocompleteComponent
          label="Empresa"
          variant="outlined"
          size="small"
          fullWidth
          options={companiesList}
          value={company}
          customAction={(value) => dispatch(handlePolicyManagmentsInputsAction("company", value))}
          name="company"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <AutocompleteComponent
          label="Planta"
          variant="outlined"
          size="small"
          fullWidth
          options={company?.stations || []}
          value={station}
          customAction={(value) => dispatch(handlePolicyManagmentsInputsAction("station", value))}
          name="station"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TextField
          label="Fecha"
          type="date"
          variant="outlined"
          size="small"
          fullWidth
          value={date}
          onChange={({ target: { value } }) => dispatch(handlePolicyManagmentsInputsAction("date", value))}
          name="date"
          inputProps={{
            max: newDate({ diffDays: 15 }),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TextField
          label="Numero de poliza"
          variant="outlined"
          size="small"
          fullWidth
          value={policyNumber}
          onChange={({ target: { value } }) =>
            dispatch(handlePolicyManagmentsInputsAction("policyNumber", value))
          }
          name="policyNumber"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RegularButton
                  color="transparent"
                  onClick={handleSearchPolicyNumber}
                >
                  Obtener numero de poliza
                </RegularButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={9}>
        <Typography variant="body1" color="info">
          Concepto: {concept}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        style={{
          display: "flex",
          gap: 4,
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}
      >
        <ButtonGroup>
          <RegularButton
            color="info"
            fullWidth
            onClick={() => handleSubmit(false)}
            loading={isLoadingComp?.search}
            disabled={
              isLoadingComp?.deletePolicyManagment ||
              isLoadingComp?.search ||
              isLoadingComp?.getPolicyNumber ||
              isLoadingComp?.getPolicy ||
              isLoadingComp?.createPolicy
            }
          >
            BuscaR
          </RegularButton>
          <RegularButton
            color="info"
            fullWidth
            onClick={handleSubmit}
            loading={isLoadingComp?.createPolicy}
            disabled={
              isLoadingComp?.deletePolicyManagment ||
              isLoadingComp?.search ||
              isLoadingComp?.getPolicyNumber ||
              isLoadingComp?.getPolicy ||
              isLoadingComp?.createPolicy
            }
          >
            Crear Poliza
          </RegularButton>
          {validateObject(policy) && policy.status === "CREATE" && (
            <RegularButton
              color="warning"
              fullWidth
              disabled={
                !validateObject(policy) ||
                isLoadingComp?.deletePolicyManagment ||
                isLoadingComp?.search ||
                isLoadingComp?.getPolicyNumber ||
                isLoadingComp?.getPolicy ||
                isLoadingComp?.createPolicy
              }
              onClick={() =>
                dispatch(deletePolicyManagmentAction(policy.id, close))
              }
              loading={isLoadingComp?.deletePolicyManagment}
            >
              eliminar poliza
            </RegularButton>
          )}
        </ButtonGroup>
      </Grid>
      {validateObject(policy) && <PolicyCounters policy={policy} />}
    </>
  );
};
